export default "__VITE_ASSET__CwlKXQ$M__"